export function download(blob, fileName: string) {
  if (window.navigator.msSaveOrOpenBlob) {
    // IE, Edge 対応
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }

  const url = URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  link.click();

  // iOS にて CSV ファイルがダウンロードできなかったため、setTimeout を追加
  // 参考サイト: https://commis.hatenablog.com/entry/2020/04/01/164534
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 200);
}
